import React from "react";
import { IMAGES } from "../config/constants";

const UserInfo = ({ user }) => {
  const { fname, lname, profileImage, id, location } = user;

  return (
    <div className="qr-notif-box">
      <img
        src={profileImage || `${process.env.PUBLIC_URL}${IMAGES.DEFAULT_AVATAR}`}
        alt="Profile"
      />
      <div className="qr-notif-details">
        <p>
          <span className="notif-span">Name:</span> {fname} {lname}
        </p>
        <p>
          <span className="notif-span">Gym Number:</span> #{id}
        </p>
      </div>
    </div>
  );
};

export default UserInfo;
